import { render, staticRenderFns } from "./inbound-call-failed-icon.vue?vue&type=template&id=8a0b9228"
import script from "./inbound-call-failed-icon.vue?vue&type=script&lang=js"
export * from "./inbound-call-failed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a0b9228')) {
      api.createRecord('8a0b9228', component.options)
    } else {
      api.reload('8a0b9228', component.options)
    }
    module.hot.accept("./inbound-call-failed-icon.vue?vue&type=template&id=8a0b9228", function () {
      api.rerender('8a0b9228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/contact-activity/inbound-call-failed-icon.vue"
export default component.exports